var _rect, _rect2, _rect3, _rect4, _rect5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaveOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 53,
    viewBox: "0 0 140 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.77637,
    y: 26.5,
    width: 36.7837,
    height: 5.07362,
    transform: "rotate(6.47122 1.77637 26.5)",
    fill: "url(#pattern0)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 25.8705,
    height: 5.07297,
    transform: "matrix(0.993629 0.112704 0.112704 -0.993629 39.4248 38.4795)",
    fill: "url(#pattern1)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 25.8705,
    height: 5.07297,
    transform: "matrix(0.826183 -0.563402 -0.563402 -0.826183 68.0234 40.2422)",
    fill: "url(#pattern2)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 87.21,
    y: 19.9355,
    width: 24.2007,
    height: 5.07297,
    transform: "rotate(-34.2914 87.21 19.9355)",
    fill: "url(#pattern3)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 110.612,
    y: 5.08789,
    width: 24.2007,
    height: 5.07297,
    transform: "rotate(-5.05394 110.612 5.08789)",
    fill: "url(#pattern4)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3468_22433",
    transform: "matrix(0.00626959 0 0 0.0454545 -0.00156739 0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3468_22433",
    transform: "matrix(0.00891321 0 0 0.0454545 -0.213057 0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3468_22433",
    transform: "matrix(0.00891322 0 0 0.0454545 -0.213057 0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern3",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3468_22433",
    transform: "matrix(0.00952821 0 0 0.0454545 -0.262257 0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern4",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3468_22433",
    transform: "matrix(0.00952821 0 0 0.0454545 -0.262257 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3468_22433",
    width: 160,
    height: 22,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveOne);
export default __webpack_public_path__ + "static/media/WaveOne.bf1a04e78ffdbd7b63e4136a3d41bb23.svg";
export { ForwardRef as ReactComponent };